import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';

import { navigate } from '~/router';

import SideMenu from '~/common/menu/SideMenu';


function SideMenuContainer(props) {
  const { route } = props;

  const items = [
    {
      iconClass: 'i-dollar',
      text: 'Payments',
      isActive: route.name.startsWith('receiver.admin.transactions'),
      onClick: (e) => navigate('receiver.admin.transactions'),
    },
    {
      iconClass: 'i-buildings',
      text: 'Locations',
      isActive: route.name.startsWith('receiver.admin.locations'),
      onClick: (e) => navigate('receiver.admin.locations'),
    },
    {
      iconClass: 'i-cog',
      text: 'Settings',
      isActive: route.name.startsWith('receiver.admin.settings'),
      onClick: (e) => navigate('receiver.admin.settings'),
    },
  ];

  return (
    <SideMenu items={items} />
  );
}


const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector('receiver.admin');

  return {
    ...routeNodeSelector(state),
  }
};

export default connect(mapStateToProps)(SideMenuContainer);
